import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { v4 as uuid } from "uuid";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import { t } from "../../Helper";
import { useSelector } from "react-redux";
import { uploadMediaData, deleteData } from "../../services/apiService";

const ServicesInfo = ({ onChange, savedServices }) => {
  const [serviceName, setServiceName] = useState("");
  const [serviceDesc, setServiceDesc] = useState("");
  const [postImage, setPostImage] = useState("");
  const [productFileName, setProductFileName] = useState("");

  const [addService, setAddService] = useState(false);

  const [services, setServices] = useState(savedServices);

  const [showDetail, setShowDetail] = useState(false);
  const [serviceDetail, setServiceDetail] = useState("");

  const [serviceList, setServiceList] = useState("Your service List");
  const [image, setImage] = useState("Image");
  const [serviceNameLabel, setServiceNameLabel] = useState("Service Name");
  const [actions, setActions] = useState("Actions");
  const [addServiceLabel, setAddServiceLabel] = useState("Add Service");
  const [addMoreService, setAddMoreService] = useState("Add More Service");
  const [addNewService, setAddNewService] = useState("Add New Service");
  const [serviceDetails, setServiceDetails] = useState("Service Details");

  const [serviceDescription, setServiceDescription] = useState(
    "Service Description"
  );
  const [uploadServiceImage, setUploadServiceImage] = useState(
    "Upload Service Image"
  );
  const [optional, setOptional] = useState("Optional");

  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          serviceList,
          currentLanguage,
          preferredLanguage
        );
        setServiceList(fetchedData);

        const fetchedData2 = await t(image, currentLanguage, preferredLanguage);
        setImage(fetchedData2);

        const fetchedData3 = await t(
          serviceNameLabel,
          currentLanguage,
          preferredLanguage
        );
        setServiceNameLabel(fetchedData3);

        const fetchedData4 = await t(
          actions,
          currentLanguage,
          preferredLanguage
        );
        setActions(fetchedData4);

        const addServiceData = await t(
          addServiceLabel,
          currentLanguage,
          preferredLanguage
        );
        setAddServiceLabel(addServiceData);

        const addMoreServiceData = await t(
          addMoreService,
          currentLanguage,
          preferredLanguage
        );
        setAddMoreService(addMoreServiceData);

        const addNewServiceData = await t(
          addNewService,
          currentLanguage,
          preferredLanguage
        );
        setAddNewService(addNewServiceData);

        const serviceDetailsData = await t(
          serviceDetails,
          currentLanguage,
          preferredLanguage
        );
        setServiceDetails(serviceDetailsData);

        const serviceDescriptionData = await t(
          serviceDescription,
          currentLanguage,
          preferredLanguage
        );
        setServiceDescription(serviceDescriptionData);

        const uploadServiceImageData = await t(
          uploadServiceImage,
          currentLanguage,
          preferredLanguage
        );
        setUploadServiceImage(uploadServiceImageData);

        const optionalData = await t(
          optional,
          currentLanguage,
          preferredLanguage
        );
        setOptional(optionalData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);

  const showserviceDetail = (detail) => {
    setServiceDetail(detail);
    setShowDetail(true);
  };

  /**
   * Save/Add New service
   */

  const saveService = () => {
    /* Validations */
    if (serviceName === "" || serviceDesc === "") {
      toast.error("Please specify name and description !");
      return false;
    }

    let serviceList = services;

    serviceList.push({
      productId: uuid(),
      name: serviceName,
      desc: serviceDesc,
      image: postImage,
      imageFileName: productFileName,
    });

    setServices(serviceList);

    setServiceName("");
    setServiceDesc("");
    setPostImage("");
    setAddService(false);

    toast.success("Saved, successfully.");
  };

  const handleServiceClose = () => {
    setAddService(false);
    setShowDetail(false);
    setServiceDetail("");
  };

  const deleteRecord = async (pId, itemImage) => {
    let serviceList = services;
    serviceList = serviceList.filter((record) => record.productId !== pId);
    setServices(serviceList);

    /* DELETE PRODUCT IMAGE */
    try {
      let mediaFileInfo = itemImage.split(".com/");
      const res = await deleteData(
        "public/api/v1/deleteMedia?file=" + mediaFileInfo[1]
      );
      toast.success("Deleted, Successfully.");
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  /* Uploading service Images */

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file != "" || file != null) {
      let isError = mediaValidationCheck(file);
      if (isError) {
        return false;
      }

      const formData = new FormData();
      formData.append("file", file);
      // make a POST request to the File Upload API with the FormData object and Rapid API headers

      try {
        const res = await uploadMediaData(
          "public/api/v1/uploadMedia",
          formData
        );
        if (res.result) {
          let mediaDetails = res.data;
          setPostImage(mediaDetails.imageUrl);
          setProductFileName(mediaDetails.fileName);
          toast.success("Service image has been uploaded, successfully.");
        } else if (!res.success) {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed to load data", error);
      }
    }
  };

  const mediaValidationCheck = (file) => {
    let isError = false;
    const fileSize = file.size / 1000;
    const allowedFileSize = ["1 MB"];
    if (fileSize > 1000) {
      toast.error(`File size must be ${allowedFileSize.join(", ")}`);
      isError = true;
    }

    const fileExtension = file.name.split(".").at(-1);
    const allowedFileTypes = ["png", "jpeg", "jpg", "gif"];
    if (!allowedFileTypes.includes(fileExtension)) {
      toast.error(
        `File does not support. Files type must be ${allowedFileTypes.join(
          ", "
        )}`
      );
      isError = true;
    }
    return isError;
  };

  useEffect(() => {
    onChange(services);
  }, [services]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="form-label section-title">{serviceList}</label>
        <div>
          <button
            id="addServiceBtn"
            type="button"
            className="btn btn-sm btn-primary"
            onClick={(e) => setAddService(true)}
          >
            <i className="bi bi-plus"></i>{" "}
            {services.length > 0 ? addMoreService : addNewService}
          </button>
        </div>
      </div>

      <div id="servicesArea" className="list-group mb-3">
        {services.map((item, index) => (
          <div
            key={index}
            className="list-group-item d-flex align-items-center justify-content-between"
          >
            <div className="d-flex align-items-center gap-3">
              {item.image === "" ? (
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                  className="product-thumb"
                ></img>
              ) : (
                <img
                  src={item.image}
                  alt={item.name}
                  className="product-thumb"
                />
              )}
              <div>
                <div className="fw-bold">{item.name}</div>
              </div>
            </div>
            <div>
              <button
                className="btn btn-sm btn-outline-secondary me-2"
                onClick={(e) => showserviceDetail(item.desc)}
              >
                <i className="bi bi-eye"></i>
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={(e) =>
                  deleteRecord(item.productId, item.imageFileName)
                }
              >
                <i className="bi bi-trash"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      <Modal show={showDetail} onHide={handleServiceClose} size="lg">
        <Modal.Header>
          <Modal.Title>{serviceDetails}</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleServiceClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>{serviceDetail}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleServiceClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={addService} onHide={handleServiceClose} size="lg">
        <Modal.Header>
          <Modal.Title>{addNewService}</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleServiceClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card p-5">
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12 p-2">
                  <input
                    type="text"
                    className="form-control"
                    value={serviceName}
                    onChange={(e) => setServiceName(e.target.value)}
                    required
                    placeholder={serviceNameLabel}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12 p-2">
                  <textarea
                    rows="5"
                    cols="33"
                    className="form-control"
                    value={serviceDesc}
                    onChange={(e) => setServiceDesc(e.target.value)}
                    required
                    placeholder={serviceDescription}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-4 p-2">
                  {uploadServiceImage} ({optional})
                </div>
                <div className="input-group col-sm-4 p-2">
                  <input
                    type="file"
                    label="Image"
                    name="myFile"
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) => handleFileUpload(e)}
                  />
                </div>
                <div className="input-group col-sm-4 p-2">
                  {postImage === "" ? (
                    <></>
                  ) : (
                    <img
                      src={postImage}
                      alt={serviceName}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100px",
                        display: "block",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleServiceClose}>
            Close
          </Button>
          <Button variant="primary" onClick={saveService}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServicesInfo;
